export enum ERoute {
  Login = '/login',
  Dashboard = '/dashboard',
  Event = '/event/:id',
}
